import type { caisseVehicule as Fr } from '../fr/caisseVehicule';

const pl = (n: number, un: string, plusieurs: string) => `${n} ${n === 1 ? un : plusieurs}`;

/** « caisseVehicule » in English — typed on the French: a missing sentence does not compile. */
export const caisseVehicule: typeof Fr = {
  etatsJour: { loue: 'rented', reserve: 'booked', entretien: 'in the garage', libre: 'available' },
  jours: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  erreurChargement: 'This vehicle could not be loaded.',
  erreurTitre: 'This page cannot be displayed',
  tarifs: (haute, basse) => ` high season ${haute} / low season ${basse} per day`,
  toutesVoitures: '← All vehicles',
  kpi: {
    genere: 'Revenue this month',
    genereDetail: (j, n) => `${pl(j, 'day', 'days')} rented · ${pl(n, 'rental', 'rentals')}`,
    encaisse: 'Collected this month',
    encaisseAvance: (m) => `of which ${m} in advance`,
    encaisseDeja: (m) => `${m} already received in an earlier month`,
    encaisseDetail: 'the money received this month',
    resteDu: 'Balance due',
    resteDuDetail: 'on this month\'s rentals',
    toutEncaisse: 'everything is collected',
    cout: 'What it cost',
    net: (m) => `net: ${m}`,
  },
  reserveApres: {
    titre: (j) => `Already booked ${pl(j, 'day', 'days')} after this month`,
    texte: ' already committed beyond the month shown. It is not earned yet, but the vehicle is no longer available.',
  },
  moisVoiture: (mois) => `The vehicle's month — ${mois}`,
  legende: { louee: 'Rented', reservee: 'Booked', entretien: 'Maintenance', libre: 'Available' },
  pied: {
    loues: (j) => `${j} d rented`,
    reserves: (j) => ` · ${j} booked`,
    garage: (j) => ` · ${j} in the garage`,
  },
  locationsMois: 'This month\'s rentals',
  pasSortie: 'This vehicle did not go out this month',
  colonnesLocations: {
    dossier: 'Rental', client: 'Customer', jours: 'Days', total: 'Total', encaisse: 'Collected', solde: 'Balance due',
  },
  aCredit: ' · on account',
  mouvements: (n) => `Every cash register movement — ${n} this month`,
  aucunMouvement: 'No cash register movements for this vehicle',
  colonnesMouvements: {
    date: 'Date', type: 'Type', quoi: 'What happened', par: 'By', recu: 'Received',
    enDevise: (devise) => `In ${devise}`,
  },
  dossier: (n) => `rental ${n}`,
  avance: (du, au) => `Collected in advance — rental from ${du} to ${au}`,
  retard: (du, au) => `Paid afterwards — rental from ${du} to ${au}`,
  annulee: 'Rental cancelled since — the money stayed',
  cout: (m) => `What the vehicle cost — ${m}`,
  aucuneDepense: 'No expenses on this vehicle this month',
  colonnesDepenses: { date: 'Date', quoi: 'What', detail: 'Details', montant: 'Amount' },
  refacturee: ' · recharged to the customer',
  note: '"Revenue" is what the vehicle produced over the days of this month, pro rata: a rental spanning two months is shared between them. "Collected" is the money actually received this month for this vehicle, whatever the rental dates: an October rental paid in September is counted in September\'s cash register, and both months point it out. So the two figures are not the same, and that is normal. "Net" deducts maintenance and fines left for you to pay.',
};
